var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    id: "Layer_1",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.262,30.516c-0.899,0-1.585,0.225-2.056,0.674c-0.471,0.451-0.707,1.115-0.707,1.994    c0,0.848,0.241,1.504,0.723,1.971c0.482,0.466,1.161,0.697,2.04,0.697c0.858,0,1.528-0.237,2.009-0.713    c0.481-0.478,0.723-1.129,0.723-1.955c0-0.857-0.238-1.518-0.715-1.979C24.803,30.745,24.131,30.516,23.262,30.516z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.329,13.703c-1.271-1.036-2.985-1.554-5.141-1.554c-2.616,0-5.092,0.654-7.425,1.962l1.711,3.438    c2.009-1.025,3.799-1.539,5.368-1.539c0.9,0,1.602,0.178,2.104,0.534c0.503,0.355,0.754,0.874,0.754,1.554    c0,0.607-0.176,1.156-0.525,1.648c-0.351,0.492-1.074,1.13-2.174,1.915c-1.141,0.837-1.926,1.627-2.354,2.37    c-0.43,0.742-0.644,1.617-0.644,2.621v1.162h4.159v-0.941c0-0.628,0.134-1.137,0.399-1.523c0.268-0.387,0.902-0.952,1.907-1.695    c1.466-1.046,2.459-1.988,2.982-2.826c0.522-0.838,0.784-1.832,0.784-2.982C31.236,16.12,30.602,14.738,29.329,13.703z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M24,44    C12.954,44,4,35.046,4,24C4,12.955,12.954,4,24,4s20,8.955,20,20C44,35.046,35.046,44,24,44z",
    fill: "#241F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.d3d94658674b3fb9e430fd1358810f7c.svg";
export { ForwardRef as ReactComponent };